const colors = {
    // Core brand
    theme: '#000000',
    purple: '#744DFF',
    portfolioGreen: '#8FE64A',
    messageGreenOverlay: '#2B3820',
    
    // Base neutrals
    black: '#000000',
    white: '#FFFFFF',
    pageDark: '#070908',
    deepNavy: '#0E0924', 
    panelDark: '#0B0820',
    panelDarkAlt: '#0D0925',
    footerDark: '#08051A',
    blogCardPanel: '#120B32',
    technology: '#140F35',
  
    // Purple family (used in gradients/glows)
    purpleAlt: '#745EF0',
    purpleBright: '#7C5CFF',
    purpleHover: '#5A3CFF',
    purpleSoft: '#6652D4',
    purpleMid: '#815EFF',
    purpleDeep: '#3E0CF2',
    violetCard: '#1A1446',
    violetAccent: '#543EB9',
    faqGradientStart: '#18133D',
    faqGradientEnd: '#110E29',
    industryGradientStart: '#110B2D',

    testimonialGreenBg: '#061d12',
    testimonialGreen: '#06C270',
    testimonialRabbitXSecondary: '#7B2A63',
    aboutUsBadgeGreenBg: '#041a10',
    aboutUsTestimonialsRabbitXBg: '#090406',
    aboutUsBadgeRabbitXBg: '#1A050D',
    messageRabbitXBg: '#2a0d14',

  // RabbitX color tokens
  rabbitXAccent: '#EE344C',
  rabbitXPageBg: '#0A0205',
  rabbitXGlowPurple: 'rgba(116,94,240,0.30)',
  rabbitXCardDark: '#12060A',
  rabbitXHighlightCardGlowStart: '#5c1d25',
  /** Top glow on RabbitX hero highlight cards (Industry / Tag / Tech) */
  rabbitXTextLight: '#F3F1FF',
  rabbitXTextBody: 'rgba(255,255,255,0.72)',
  rabbitXChallengeCardA: 'rgba(238,52,76,0.10)',
  rabbitXChallengeCardB: 'rgba(116,94,240,0.10)',
  rabbitXChallengeCardC: 'rgba(143,230,74,0.10)',
  rabbitXOutcomeCardA: 'rgba(238,52,76,0.10)',
  rabbitXOutcomeCardB: 'rgba(116,94,240,0.10)',

  // ARB Venture tokens
  arbVenturePageBg: '#0B0D0B',
  arbVentureHeroBg: '#101210',
  arbVentureAccent: '#59892f',
  arbVentureAccentBright: '#83C74A',
  arbVentureCardBg: '#131714',
  arbVentureCardBorder: '#3F5F2B',
  arbVentureTextMuted: '#eaefe8',
  arbVentureGlow: 'rgba(111,175,56,0.26)',

  // ArbVenture lighter theme tokens (for Testimonial / Message / FAQ)
  arbVentureThemeAccent: '#5F9937',
  arbVentureThemeAccentBright: '#8FE64A',
  arbVentureThemeCardBg: '#0d1a08',
  arbVentureThemeMessageBg: '#1a2a12',
  arbVentureThemeTopGlow: '#5F9937',
  arbVentureThemeFaqBg: '#0e1809',

  // TatvaCare / light pink theme tokens
  lightPinkAccent: '#E8B4F0',
  lightPinkAccentBright: '#F5C6EF',
  lightPinkSecondary: '#A461D8',
  lightPinkDeep: '#4B4AD5',
  lightPinkCardBg: '#1a1028',
  lightPinkMessageBg: '#241530',
  lightPinkFaqBg: '#18102a',
  testimonialcardbg: '#b97aeb',
  testimonialLightPinkBg: '#1a0f28',
  lightPinkBadgeBg: 'rgba(245, 198, 239, 0.42)',
  lightPinkBadgeSolid: '#F5C6EF',
  testimonialLightPinkCardGlass: 'rgba(164, 97, 216, 0.38)',

  // Portfolio stats style tokens
  portfolioStatsFillStart: 'rgba(19, 3, 71, 0.692)',
  portfolioStatsFillMid: 'rgba(23, 15, 49, 0.432)',
  portfolioStatsHoverEnd: '#744EF0',
  portfolioStatsNumberHover: '#0E0924',
  
  
    // Text / muted
    textMuted: '#BBBBBB',
    textMutedAlt: '#C4C0DA',
  
    // Extra accents found in constants/content
    orange: '#EA8B30',
    indigo: '#4532C4',
    magenta: '#CC35C2',
    violetPink: '#C02CDE',
    rose: '#ED4D7F',

  
    // About/industry gradient stops
    aboutLineA: '#4530A0',
    aboutLineB: '#4F3EA6',
    aboutLineC: '#47435E',
    aboutLineD: '#1E173D',
    aboutLineE: '#0F0C22',
    contactInfoCardsBg: '#744DFF80',
    industryA: '#140E2E',
    industryB: '#181133',
    industryC: '#6C50E9',
    industryD: '#27195E',
    industryE: '#160F36',
    industryF: '#1E163F',
    industryG: '#19103D',
    industryHoverStart: '#FF8C20',
    industryHoverEnd: '#FF6D52',
    technologyStepBadgeStart: '#EA892A',
   
    technologyStepBadgeEnd: '#E35384',
    technologyStepCardBorderStart: '#5E3CD9',
    technologyStepCardBorderEnd: 'rgba(50, 32, 115, 0)',
    complianceOverlay: 'rgba(19, 12, 47, 0.55)',
  
    // Alpha hex values used directly
    white10Hex: '#FFFFFF1A',
    white20Hex: '#FFFFFF33',
    pinkGlowHex: '#9203A533',

    // Service page palette
    // Consolidated: use existing tokens `deepNavy`, `purpleAlt`, and `panelDark` instead of duplicates.
    serviceBadgeAltBg: '#130F31',
    serviceHeroBody: 'rgba(255,255,255,0.64)',
    serviceAutomationBody: '#9CA3AF',
    serviceDevelopmentBody: '#A9A2BB',
    serviceConsultingBody: '#B4ABC7',
    serviceAutomationCardDocumentBg: 'rgba(21,15,51,0.50)',
    serviceAutomationCardPredictiveBg: 'rgba(31,17,40,0.50)',
    serviceAutomationCardWorkflowBg: 'rgba(21,19,54,0.50)',
    serviceAutomationCardConversationBg: 'rgba(29,20,38,0.50)',
    serviceGlowPurple: 'rgba(116,77,255,0.23)',
    serviceGlowSunset: 'rgba(227,83,132,0.15)',
    serviceAccentOrange: '#EA892A',
    serviceAccentOrangeSoft: '#F48A4B',
    serviceAccentPink: '#E35384',
    serviceDevelopmentImageBorder: 'rgba(82,68,144,0.44)',
    serviceDevelopmentTextBorder: 'rgba(106,74,117,0.52)',
    serviceDevelopmentImageGlowA: 'rgba(114,75,255,0.18)',
    serviceDevelopmentImageGlowB: 'rgba(154,92,235,0.18)',
    serviceDevelopmentImageGlowC: 'rgba(110,84,255,0.14)',
    serviceDevelopmentOrbBorder: 'rgba(187,118,156,0.08)',
    serviceDevelopmentOrbFill: 'rgba(167,99,149,0.10)',
    serviceDevelopmentOrbFillSoft: 'rgba(167,99,149,0.04)',
    serviceDevelopmentShadow: 'rgba(8,5,30,0.36)',
    /* serviceConsultingCardBg removed (duplicate of deepNavy) */
    serviceConsultingCardCenterBg: '#11092E',
    serviceConsultingCenterGlow: 'rgba(82, 60, 180, 0.22)',
    serviceConsultingCenterRadialA: 'rgba(96, 72, 208, 0.18)',
    serviceConsultingCenterRadialB: 'rgba(96, 72, 208, 0.09)',
    serviceConsultingCenterRadialC: 'rgba(96, 72, 208, 0)',
    serviceEngagementCardInnerBg: '#0D0B21',
    serviceConsultingInnerGlow: 'rgba(82, 60, 180, 0.20)',
    serviceConsultingInnerRadialA: 'rgba(96, 72, 208, 0.16)',
    serviceConsultingInnerRadialB: 'rgba(96, 72, 208, 0.07)',
    serviceConsultingInnerRadialC: 'rgba(96, 72, 208, 0)',

    // Cryptonary palette
    cryptonaryPageGradientFrom: '#03170F',
    cryptonaryPageGradientVia: '#052115',
    cryptonaryPageGradientTo: '#020E09',
    cryptonarySectionBase: '#000F06',
    cryptonaryHeroBase: '#021A12',
    cryptonaryAccentGreen: '#00C241',
    cryptonaryGlowPrimary: '#00743D',
    cryptonaryGlowSecondary: '#005E31',
    cryptonaryLineGreen: '#5E8978',
    cryptonaryLineMint: '#82B59F',
    cryptonaryLineSoftMint: '#C7E2D6',
    cryptonaryTextHeroBody: '#E7EFE8',
    cryptonaryTextOverviewBody: '#DFE9E2',
    cryptonaryTextChallengeBody: '#E5F0E9',
    cryptonaryTextFeatureBody: '#E6EFE9',
    cryptonaryTextBuiltBody: '#EDF4EF',
    cryptonaryTextImpactBody: '#DCE8E0',
    cryptonaryFeatureIconRing: '#0B7A55',
    cryptonaryFeatureIconBg: '#03120A',
    cryptonaryFeatureCardBg: '#0A1F14',
    cryptonaryBuiltBorder: '#00994F',
    cryptonaryHeroNumberStroke: '#00AA41',
    cryptonaryHeroRadialA: '#074C30',
    cryptonaryHeroRadialB: '#04261B',
    cryptonaryHeroLinear: '#021C14',
    cryptonaryChallengeOverlayA: '#084E34',
    cryptonaryChallengeOverlayB: '#07422D',
    cryptonaryChallengeOverlayC: '#053021',
    cryptonaryChallengeOverlayD: '#021810',
    cryptonaryChallengeCardA: '#188244',
    cryptonaryChallengeCardB: '#0A4E2A',
    cryptonaryChallengeCardC: '#041C12',
    cryptonaryOverviewCoinGlow: '#437AFF',
    cryptonaryFeatureCoinGlow: '#08121C',
    cryptonaryBuiltCoinGlow: '#FF9E1C',
    cryptonaryImpactCoinGlow: '#0082FF',

    // DDX tokens
    ddxPageBg: '#1A0D2D',
    ddxHeroOverlay: 'rgba(42,0,82,0.48)',
    ddxSectionGradient: 'linear-gradient(293.91deg, #2B0946 -61.94%, #5E0F9B 100%)',
    ddxAccentDark: '#2B0946',
    ddxAccent: '#5E0F9B',
    ddxmessageinput: '#6e3f92',
    ddxAccentBright: '#1A0D2D',
    ddxAccentSoft: '#1A0D2D',
    ddxMessageBg: '#8928c7',
    ddxFaqBg: '#7c15bd',
    ddxBadgeSolid: '#7c15bd',
    ddxBadgeBg: 'rgba(155, 63, 212, 0.42)',
    testimonialDdxBg: '#8928c7',

    // Medilearn tokens
    medilearnPageBg: '#9BB069',
    medilearnAccent: '#9BB069',
    medilearnAccentDark: '#708246',
    medilearnAccentBright: '#B6C887',
    medilearnBadgeBg: 'rgba(155, 176, 105, 0.42)',
    medilearnBadgeSolid: '#9BB069',
    testimonialMedilearnBg: '#8A9D5B',
    medilearnSectionGradient: 'linear-gradient(293.91deg, #708246 -61.94%, #9BB069 100%)',

    // Upskill tokens
    upskillPageBg: '#080321',
    upskillSectionBg: '#07031B',
    upskillHeroOverlayStart: 'rgba(7,3,25,0.12)',
    upskillHeroOverlayMid: 'rgba(7,3,25,0.22)',
    upskillHeroOverlayEnd: 'rgba(7,3,25,0.48)',
    upskillHeroMaskStart: 'rgba(0,0,0,0.95)',
    upskillHeroMaskMidA: 'rgba(0,0,0,0.72)',
    upskillHeroMaskMidB: 'rgba(0,0,0,0.28)',
    upskillHeroMaskEnd: 'rgba(0,0,0,0)',
    upskillStatCardBase: 'rgba(0,0,0,0.2)',
    upskillStatCardHover: '#6C56F5',
    upskillStatCardHoverSoft: 'rgba(108,86,245,0.9)',
    upskillStatCardHoverShadow: 'rgba(108,86,245,0.35)',
    upskillExpertiseCardBg: 'rgba(17,11,43,1)',
    upskillExpertiseCardBorder: 'rgba(25,16,65,1)',
    upskillGapGlow: 'rgba(116,77,255,1)',
    upskillCourseCardBg: 'rgba(34,22,86,1)',
    upskillCourseCardBgEnd: 'rgba(24,15,67,1)',
    upskillCourseCardShadow: 'rgba(0,0,0,0.35)',
    upskillStatusGradientStart: '#EA892A',
    upskillStatusGradientEnd: '#E35384',
    upskillEnrollButtonBg: 'rgba(116,77,255,0.3)',
    upskillModalBorder: '#744DFF66',
    upskillModalBg: '#130A31',
    upskillDropdownBg: '#0f0925',
    upskillSearchBg: '#130A31',
    upskillScrollbarTrack: 'rgba(255,255,255,0.12)',
    upskillCheckAccent: '#744DFF',
  }

export default colors
